import React from 'react';
import './CompanyOverview.css';

const CompanyOverview = () => {
    return (
        <div className="company-wrapper">
            <div className="company-card">
                <h1 className="main-heading">🌐 Company Overview – Globallink Corporation</h1>
                <p className="tagline">"Connecting Global Trade with Quality & Trust"</p>

                <section>
                    <p>
                        <strong>Globallink Corporation</strong> is a trusted and rapidly expanding <strong>import-export company</strong> based in <strong>Ankleshwar GIDC, Gujarat, India</strong>, delivering end-to-end international trade solutions.
                    </p>
                    <p>
                        We specialize in the global supply of high-quality <strong>pharmaceutical excipients, API intermediates, chemicals, solvents, medical wearables</strong>, and <strong>industrial and consumer products</strong>. With a strong network of certified manufacturers and partners, we ensure quality, compliance, and timely delivery.
                    </p>
                </section>

                <h2>✅ Our Import & Export Expertise</h2>
                <ul>
                    <li>🌍 Global Trade with China, Japan, Switzerland, USA, Europe, UAE, and more</li>
                    <li>📦 Products: Pharma APIs, consumer goods, electronics, kitchenware</li>
                    <li>🚢 Multi-modal logistics with full documentation & customs support</li>
                    <li>📑 International compliance: HS codes, COA, MSDS, INCOTERMS</li>
                    <li>🔍 Quality control before every shipment</li>
                    <li>🤝 Reliable network of global buyers and suppliers</li>
                    <li>📈 Bulk & repeat shipments with real-time tracking</li>
                </ul>

                <h2>🧾 Core Product Segments</h2>
                <ul>
                    <li>Pharma Excipients – MCC, PEGs, Polysorbates, etc.</li>
                    <li>API Intermediates – Doxycycline Hyclate, Piperazine Citrate</li>
                    <li>Food & Pharma Oils – Lecithin, HVO, Corn Oil</li>
                    <li>Solvents – Methanol, Toluene, Ethanol</li>
                    <li>Medical Wearables – Disposable gloves, safety kits</li>
                </ul>

                <h2>🌍 Export Reach & Services</h2>
                <ul>
                    <li>Markets: UAE, Europe, Southeast Asia, Africa, CIS</li>
                    <li>Delivery Terms: EXW, FOB, CIF, DDP</li>
                    <li>End-to-end trade support from sample to shipment</li>
                </ul>

                <h2>🔒 Why Choose Us?</h2>
                <ul>
                    <li>✅ Global quality & safety compliance</li>
                    <li>✅ Long-term buyer/supplier trust</li>
                    <li>✅ Full trade transparency & ethical practice</li>
                </ul>

                <h2>📍 Contact Us</h2>
                <p>
                    <strong>Globallink Corporation</strong><br />
                    Platinum Plaza, F-5, Near New Lions School,<br />
                    Ankleshwar GIDC, Gujarat 393001, India<br />
                    📧 info@globallinkcorporation.com<br />
                    🌐 www.globallinkcorporation.com
                </p>
            </div>
        </div>
    );
};

export default CompanyOverview;
